import { reactive, ref } from 'vue'

import api from '@/store/api'

const ENDPOINT = 'catering_delivery_settings'

export const LEAD_TIME_UNITS = [
  { name: 'hours', value: 'hours' },
  { name: 'days', value: 'days' }
]

export function useCateringDeliverySettings() {
  const form = reactive({ delivery_fee_cents: null, lead_time_amount: null, lead_time_unit: 'days' })
  const upcomingDeliveryDates = ref(0)

  const read = response => {
    const data = response?.data || {}
    form.delivery_fee_cents = data.delivery_fee_cents || null
    form.lead_time_amount = data.lead_time?.amount ?? null
    form.lead_time_unit = data.lead_time?.unit || 'days'
    upcomingDeliveryDates.value = data.upcoming_delivery_dates ?? 0
  }

  const load = () => api.call('GET', ENDPOINT, {}, { receive: false }).then(read)

  const save = () =>
    api
      .call(
        'PUT',
        ENDPOINT,
        {
          catering_delivery_settings: {
            delivery_fee_cents: form.delivery_fee_cents ?? 0,
            lead_time: { amount: form.lead_time_amount, unit: form.lead_time_unit }
          }
        },
        { receive: false }
      )
      .then(read)

  return { form, upcomingDeliveryDates, load, save }
}
